import { toast } from 'react-toastify';
import { Uuid } from '@/api/types';
import { retrieveUnifiedError } from '@/api/utils';
import { useAssignUserToCaseGroup } from '@/queries/case';
import { AssignedUser, CaseUserGroup } from '@/api/apis/case';

export const useSetIsPrimaryUser = ({ caseId }: { caseId: Uuid }) => {
  const { mutateAsync: mutateSetIsPrimaryUser, isPending: isPendingSetIsPrimaryUser } = useAssignUserToCaseGroup();

  const handleSetIsPrimaryUser = async ({
    group,
    employeeId,
    assignedUsers,
    usersToUpdate,
    onClose,
  }: {
    group?: CaseUserGroup;
    employeeId?: string;
    assignedUsers?: Partial<Record<CaseUserGroup, AssignedUser[]>>;
    usersToUpdate?: Partial<Record<CaseUserGroup, AssignedUser[]>>;
    onClose?: () => void;
  }) => {
    try {
      const payload = [];

      if (usersToUpdate && assignedUsers) {
        for (const [key, value] of Object.entries(usersToUpdate)) {
          payload.push({
            action: 'assign' as const,
            employeeId: value[0].employeeId,
            group: key as CaseUserGroup,
            isPrimary: value[0].isPrimary,
          });
        }
      }

      if (employeeId) {
        payload.push({
          action: 'assign' as const,
          employeeId,
          group: group!,
          isPrimary: false,
        });
      }

      await mutateSetIsPrimaryUser({ caseId, payload });
      toast.success(`Resource has been successfully updated`);
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    } finally {
      if (onClose) {
        onClose();
      }
    }
  };

  return { handleSetIsPrimaryUser, isPendingSetIsPrimaryUser };
};
